<template>
  <div class="pt-10 ml-0 mr-0 mt-n3 white" style="max-width: 400px; width: 100%;">
    <initialize-progress :step="step" @click="onStepClicked"/>
    <template v-if="step==1">
      <user-data-slim class="mx-0" ref="userData" :show_save_btn="false"></user-data-slim>
    </template>
    <template v-else-if="step==2">
      <erfolgsmatrix ref="erfolgsMatrix"></erfolgsmatrix>
    </template>
    <template v-else-if="step==3">
      <activities ref="activities"></activities>
    </template>
    <v-row>
      <v-spacer></v-spacer>
      <v-btn v-if="step<3" class="mb-10 gelb" @click="saveAndNext">Weiter</v-btn>
      <v-btn v-if="step==3" class="mb-10 gelb" @click="saveAndExit">Speichern</v-btn>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>

<script>
import InitializeProgress from "@/components/InitializeProgress";
import Erfolgsmatrix from "@/components/Erfolgsmatrix";
import Header1 from "@/components/Header1";
import UserData from "@/views/UserData";
import Activities from "@/components/Activities";
import UserDataSlim from "@/views/UserDataSlim";

export default {
  name: "InitializeUser",
  components: {Activities, UserDataSlim, InitializeProgress, Erfolgsmatrix, Header1},
  data() {return{
    step:1,
  }},
  methods: {
    async save() {
      if (this.step==1) {
        if (!this.$refs.userData.canContinue())
          return false;
        await this.$refs.userData.save();
      }
      else if (this.step==2) {
        await this.$refs.erfolgsMatrix.save();
      }
      return true;
    },
    async saveAndNext() {
      var canContinue=await this.save();
      if (!canContinue)
        return false;
      this.step++;
    },
    async saveAndExit() {
      await this.$refs.activities.save();
      this.$emit("done");
    },
    async onStepClicked(nr) {
      await this.save();
      this.step=nr;
    }
  }
}
</script>

<style scoped>

</style>